import React from 'react'
import './SimpleRow.scss'

// A simple "row" container.
function SimpleRow (props) {
  return <div className="simple-row">{props.children}</div>
}

export default SimpleRow
